import { render, staticRenderFns } from "./OrganizerMessages.vue?vue&type=template&id=0d413e31&scoped=true"
import script from "./OrganizerMessages.vue?vue&type=script&lang=js"
export * from "./OrganizerMessages.vue?vue&type=script&lang=js"
import style0 from "./OrganizerMessages.vue?vue&type=style&index=0&id=0d413e31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d413e31",
  null
  
)

export default component.exports